export { default } from "ember-stereo/-private/utils/strategy";
